// extracted by mini-css-extract-plugin
var _1 = "close--S8Ed3ndz";
var _2 = "panel--XTNrbGX_";
export { _1 as "close", _2 as "panel" }
